import {CampaignCommentsState} from './campaignComments.types';

const campaignCommentsInitialState: CampaignCommentsState = {
  selectedCommentNumber: 0,
  activeUsers: [],
  commentNodeId: 0,
  comments: [],
  prevScaleTranslate: null,
  showResolved: false,
  filteredComments: [],
  inAddCommentState: false,
};

export {campaignCommentsInitialState};
